var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 63.2C53.4993 63.2 61.2 55.4993 61.2 46C61.2 36.5007 53.4993 28.8 44 28.8C34.5007 28.8 26.8 36.5007 26.8 46C26.8 55.4993 34.5007 63.2 44 63.2ZM44 65C54.4934 65 63 56.4934 63 46C63 35.5066 54.4934 27 44 27C33.5066 27 25 35.5066 25 46C25 56.4934 33.5066 65 44 65Z",
    fill: "#2ba2de"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 58.2C50.7379 58.2 56.2 52.7379 56.2 46C56.2 39.2621 50.7379 33.8 44 33.8C37.2621 33.8 31.8 39.2621 31.8 46C31.8 52.7379 37.2621 58.2 44 58.2ZM44 60C51.732 60 58 53.732 58 46C58 38.268 51.732 32 44 32C36.268 32 30 38.268 30 46C30 53.732 36.268 60 44 60Z",
    fill: "#2ba2de"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6773 73.607L53.3636 62.2933L54.6364 61.0205L65.9501 72.3342C67.1607 73.5448 69.1236 73.5448 70.3342 72.3342C71.5448 71.1236 71.5448 69.1608 70.3342 67.9501L59.0205 56.6364L60.2933 55.3636L71.607 66.6773C73.5205 68.5909 73.5205 71.6934 71.607 73.607C69.6934 75.5206 66.5909 75.5206 64.6773 73.607Z",
    fill: "#2ba2de"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1 8.99998C47.1 5.7415 49.7415 3.09998 53 3.09998C56.2585 3.09998 58.9 5.7415 58.9 8.99998V16.5593C58.9 17.2997 58.2998 17.9 57.5593 17.9H48.9V44.75C48.9 48.6988 45.6988 51.9 41.75 51.9H32V50.1H37.0065C35.5303 48.7902 34.6 46.8787 34.6 44.75V40.9H32V39.1H35.2412C35.8812 39.1 36.4 39.6188 36.4 40.2588V44.75C36.4 47.7047 38.7953 50.1 41.75 50.1C44.7047 50.1 47.1 47.7047 47.1 44.75V8.99998ZM48.9 16.1H57.1V8.99998C57.1 6.73561 55.2644 4.89998 53 4.89998C50.7356 4.89998 48.9 6.73561 48.9 8.99998V16.1ZM8.00001 40.9C7.94478 40.9 7.90001 40.9447 7.90001 41V44C7.90001 47.3689 10.6311 50.1 14 50.1H26.5V51.9H14C9.63696 51.9 6.10001 48.363 6.10001 44V41C6.10001 39.9506 6.95067 39.1 8.00001 39.1H26.5V40.9H8.00001Z",
    fill: "#2ba2de"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4.89998C17.6311 4.89998 14.9 7.63104 14.9 11V40H13.1V11C13.1 6.63693 16.637 3.09998 21 3.09998H53V4.89998H21Z",
    fill: "#2ba2de"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 28C20.1 27.5029 20.5029 27.1 21 27.1H41C41.4971 27.1 41.9 27.5029 41.9 28C41.9 28.497 41.4971 28.9 41 28.9H21C20.5029 28.9 20.1 28.497 20.1 28Z",
    fill: "#2ba2de"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 18C20.1 17.5029 20.5029 17.1 21 17.1H41.5C41.9971 17.1 42.4 17.5029 42.4 18C42.4 18.497 41.9971 18.9 41.5 18.9H21C20.5029 18.9 20.1 18.497 20.1 18Z",
    fill: "#2ba2de"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 13C20.1 12.5029 20.5029 12.1 21 12.1H36C36.4971 12.1 36.9 12.5029 36.9 13C36.9 13.497 36.4971 13.9 36 13.9H21C20.5029 13.9 20.1 13.497 20.1 13Z",
    fill: "#2ba2de"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 33C20.1 32.5029 20.5029 32.1 21 32.1H31C31.4971 32.1 31.9 32.5029 31.9 33C31.9 33.497 31.4971 33.9 31 33.9H21C20.5029 33.9 20.1 33.497 20.1 33Z",
    fill: "#2ba2de"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 23C20.1 22.5029 20.5029 22.1 21 22.1H41.5C41.9971 22.1 42.4 22.5029 42.4 23C42.4 23.497 41.9971 23.9 41.5 23.9H21C20.5029 23.9 20.1 23.497 20.1 23Z",
    fill: "#2ba2de"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.9f0c812c1795266e750608050b4f40ec.svg";
export { ForwardRef as ReactComponent };